module.exports = __webpack_public_path__ + "img/HIDE.e819e492.svg";